import {
    availableServices,
    cancelPolarService,
    cancelSteinerReservation,
    cpNavigationHeaderUrl,
    getBenefits,
    getContentFeed,
    polarItenerariesToken,
    reservedServices,
    pclClientId,
} from '../api/apiConstants';

import { userLogOut } from './user.actions'
import { apiRequestsConstants, durationOptions } from '../utils/spaConstants'
import { getData, postData } from '../utils/spaUtils'
import {
    SERVICES_BENEFITS,
    SERVICES_CATEGORIES,
    SERVICES_FETCH_SUCCESS,
    SET_AUTH_TOKEN,
    SET_BOOKING_DETAILS,
    SET_CANCELED_SERVICE,
    SET_CONTENT_FEED,
    SET_CRUISE_DATE,
    SET_GUEST_PAYER,
    SET_ITINERARIES,
    SET_NAV_DATA,
    SET_RESERVED_SERVICES,
    SET_SELECTED_GUEST_DETAILS,
    SET_SELECTED_SERVICE,
    SET_SERVICE_FILTER,
    SET_SHOW_FIL_SERVICES,
} from './actionTypes'
import * as servicesHelpers from './helpers/servicesActionHelper'
import { setNotificationBanner, setPaymentLoader } from './payment.actions'
import moment from 'moment'
import { runInNewContext } from 'vm';
import startsWith from 'lodash/startsWith';
import { stringify } from 'querystring';


export const servicesLoading = (bool) => {
    return {
        type: 'SET_SERVICES_LOADING',
        isLoading: bool,
    }
}

export const itemsFetchDataSuccess = (items) => {
    return {
        type: SERVICES_FETCH_SUCCESS,
        items,
    }
}

export const setServiceCategories = (Categories) => {
    return {
        type: SERVICES_CATEGORIES,
        Categories,
    }
}

export const setServiceBenefits = (benefits) => {
    return {
        type: SERVICES_BENEFITS,
        benefits,
    }
}

export const filterByServiceByCategory = (category) => {
    return (dispatch, getState) => {
        let { services = {} } = getState()
        let { filter = {} } = services
        filter.selectedCategory = category === filter.selectedCategory ? '' : category
        dispatch(setFilter({ ...filter }))
        dispatch(servicesFetchData(filter))
    }
}

export const setFilter = (filter) => {
    return {
        type: SET_SERVICE_FILTER,
        filter: { ...filter },
    }
}

export const showFilteredServices = (isShow) => {
    return {
        type: SET_SHOW_FIL_SERVICES,
        showFilteredServices: isShow,
    }
}

export const setCruiseDates = (cruiseStartDate, cruiseEndDate) => {
    return {
        type: SET_CRUISE_DATE,
        cruiseStartDate,
        cruiseEndDate,
    }
}

export const setSelectedDate = (selectedDate, year, reqdate) => {
    return (dispatch, getState) => {
        let { services = {} } = getState()
        let { filter = {} } = services
        if (selectedDate === filter.selectedDate) {
            filter.selectedDate = ''
            filter.selectedYear = ''
            filter.startDate = services.cruiseStartDate
            filter.endDate = services.cruiseEndDate
        } else {
            filter.selectedDate = selectedDate
            filter.selectedYear = year
            filter.startDate = reqdate
            filter.endDate = reqdate
        }

        filter.selectedTimeSlot = ''
        dispatch(setFilter({ ...filter }))
        dispatch(servicesFetchData({ ...filter }))
    }
}

export const fetchedBookingDetails = (guestDetails, Booking, guestName, PaymentDetails, bookingCatagory) => {
    return {
        type: SET_BOOKING_DETAILS,
        guestDetails,
        bookingDetails: Booking,
        guestName,
        PaymentDetails,
        bookingCatagory: bookingCatagory
    }
}

export const fetchedReservedServices = (reservedServices, booking) => {
    return {
        type: SET_RESERVED_SERVICES,
        reservedServices,
        polarRes: booking
    }
}

export const servicesFetchData = (filter, spaId, selectedSort) => {
    return async (dispatch, getState) => {
        dispatch(servicesLoading(true))
        let { services } = getState()
        let _filter = filter ? servicesHelpers.getReqBody(filter, services) : servicesHelpers.getReqBody(services.filter, services)
        if (services.filter) {
            _filter.StartDate = services.filter.startDate
            _filter.EndDate = services.filter.endDate
        }
        let reqHeader = {}
        reqHeader.AuthToken = services.authDetails.AuthToken
        reqHeader.AppId = 'SPA' + services.authDetails.AuthToken
        reqHeader.ProductCompany = 'PC';
        reqHeader.BookingCompany = 'PC';
        reqHeader['pcl-client-id'] = pclClientId	
        try {
            const response = await postData(availableServices, _filter, reqHeader)
            //console.log(response);
            let payload = response.json()
            if (!response.ok) { 
                payload.then((error) => {
                    console.log(error.message);
                 
                    if(error.message === "Cruise Not Found"){
                        dispatch(showSpaCruiseNotFound(error.message, true));
                        return;
                    } else if (error.message !== "No Services met the requested criteria") {
                        dispatch(showSpaError(error.message, true));
                        return;
                    } else {
                        servicesHelpers.processServices([], dispatch, filter, getState)
                    }
                })
            }
            dispatch(servicesFetchBenefits())
            if (response.ok) {
                payload.then((items) => {
                    console.log("Successfully fetched the response based on filter")
                    servicesHelpers.processServices(items, dispatch, filter, getState, spaId, selectedSort)
                })
                .then(() => dispatch(servicesLoading(false)))
            }
        } catch (e) {
            dispatch(showSpaError(e))
        }
    }
}

export const showSpaError = (e, isErrorPage) => {
    return (dispatch, getState) => {
        let errorMsg = typeof e === 'string' ? e : 'Error while fetching data'
        // toast.error(errorMsg, {
        //     containerId: 'spa-toast-msg',
        //     position: toast.POSITION.BOTTOM_RIGHT,
        // });
        console.log(errorMsg);
        if (isErrorPage)
            window.location.href = '/lotus-spa/error';
    }
}

export const showSpaCruiseNotFound = (e, isErrorPage) => {
    return (dispatch, getState) => {
        let errorMsg = typeof e === 'string' ? e : 'Error while fetching data'
        // toast.error(errorMsg, {
        //     containerId: 'spa-toast-msg',
        //     position: toast.POSITION.BOTTOM_RIGHT,
        // });
        console.log(errorMsg);
        if (isErrorPage)
            window.location.href = '/lotus-spa/cruisenotfound';
    }
}


export const servicesFetchBenefits = (filter) => {
    return async (dispatch, getState) => {
        try {
            let { services } = getState();
            let reqHeader = {}
            reqHeader.AuthToken = services.authDetails.AuthToken
            reqHeader.AppId = 'SPA' + services.authDetails.AuthToken
            reqHeader.ProductCompany = 'PC';
            reqHeader.BookingCompany = 'PC';
            reqHeader['pcl-client-id'] = pclClientId	
            const response = await getData(getBenefits, reqHeader)
            if (!response.ok) {
                throw Error(response.statusText)
            }
            let payload = response.json()
            payload.then((items) => dispatch(setServiceBenefits(items.data)))
        } catch (e) {
            dispatch(showSpaError(e))
        }
    }
}

export const getReservedServices = (url) => {
    return async (dispatch, getState) => {
        let { services } = getState()
        if (!services.authDetails || !services.authDetails.AuthToken) {
            dispatch(unauthorizedAccess)
            return
        }
        services.authDetails.pclClientId = pclClientId;
        let polarHeader = servicesHelpers.getBookingsHeader(services.authDetails)
        try {
            dispatch(setScreenLoading(true));
            const response = await getData(url, polarHeader)
            let payload = response.json()
            if (!response.ok) {
                payload.then((error) => {
                    console.log(error.message);
                    dispatch(showSpaError(error.message, true));
                    dispatch(setScreenLoading(false));
                })
            }
            payload.then((items) => {
                servicesHelpers.processBookingDetails(items, dispatch, getState)
                dispatch(setScreenLoading(false)); 
            })
        } catch (e) {
            dispatch(showSpaError(e, true));
            dispatch(setScreenLoading(false));
        }
    }
}

export const cancelSelectedService = (selectedService) => {
    return async (dispatch, getState) => {
        let { services } = getState()
        let reqHeader = {}
        reqHeader.AuthToken = services.authDetails.AuthToken
        reqHeader.AppId = 'SPA' + services.authDetails.AuthToken
        reqHeader.ProductCompany = 'PC';
        reqHeader.BookingCompany = 'PC';
        reqHeader['pcl-client-id'] = pclClientId	

        let _cancelSteinerReservation = `${cancelSteinerReservation}?vesselId=${services.bookingDetails.vesselId}&&resHoldId=${selectedService.appointment.ResHoldId}`

        try {
            const response = await getData(_cancelSteinerReservation, reqHeader);
            let payload = response.json()

            if (!response.ok) {
                dispatch(setNotificationBanner('Unable to Cancel Reservation. Please Try Again.', 'fail'));
                payload.then((error) => {
                    console.log(error.message);
                });
                throw Error(response.statusText)
            }
            payload.then((result) => {
                dispatch(cancelPolarServices(selectedService))     
            });
        } catch (e) {
            dispatch(setNotificationBanner('Unable to Cancel Reservation. Please Try Again.', 'fail'))
        }
    }
}

export const cancelPolarServices = (selectedService) => {
    return async (dispatch, getState) => {
        let _state = getState();
        let { services } = _state;
        let { contentFeedData = false } = services

        let { BookingNumber } = _state.services.bookingDetails
        let reqHeader = {}
        reqHeader.AuthToken = _state.services.authDetails.AuthToken
        reqHeader.AppId = 'SPA' + _state.services.authDetails.AuthToken
        reqHeader.ProductCompany = 'PC'
        reqHeader.BookingCompany = 'PC'
        reqHeader['pcl-client-id'] = pclClientId
        
        let url = cancelPolarService.replace('{bookingNumber}', BookingNumber)
        let _reqBody = servicesHelpers.getCancelReqBody(selectedService, _state)
        dispatch(setScreenLoading(true));
        const response = await postData(url, _reqBody, reqHeader)
        if (!response.ok) {
            dispatch(setScreenLoading(false));
            let labelText = `Unable to Cancel Your Reservation for ${selectedService.appointment.treatmentName}.Please Try Again`
            dispatch(setNotificationBanner(labelText, 'fail'))
            throw Error(response.statusText)
        }
        let payload = response.json();
        payload.then((response) => {
            //console.log(response);
            let spaName = '';
            //let advCode = response.POLARResponse.RespMsgHeader.RespStatus.Advisory[0].ReasonCode;
            // if (startsWith(advCode, '0') || startsWith(advCode, '1') || startsWith(advCode, '2')) {
                dispatch(removeReservations(_reqBody));
                if (!selectedService.appointment.treatmentName) {
                    if (contentFeedData) {
                        let contentData = contentFeedData.find(
                            (data) => data.productCode == selectedService.appointment.SpaId
                        )
                        spaName = contentData
                            ? contentData.productName
                            : ''
                    }
                }
                let labelText = spaName || selectedService.appointment.treatmentName ?
                    `Your Reservation for ${selectedService.appointment.treatmentName || spaName} has been cancelled` :
                    `Your Reservation has been cancelled`;

                dispatch(setNotificationBanner(labelText, 'fail'))
                dispatch(cancelSuccess(selectedService))
                dispatch(setScreenLoading(false))

           // } 
        });
        // dispatch(getReservedServices(reservedServices))
    }
}

export const cancelSuccess = (selectedService) => {
    return {
        type: SET_CANCELED_SERVICE,
        canceledService: selectedService,
    }
}

export const filterByBenfit = (benefit) => {
    return  (dispatch, getState) => {
        let { services = {} } = getState()
        let { filter = {} } = services
        if (filter.selectedBenefit === benefit) {
            filter.selectedBenefit = ''
            dispatch(setFilter({ ...filter }))
            dispatch(servicesFetchData(filter))
            return
        }
        filter.selectedBenefit = benefit
        dispatch(setFilter({ ...filter }))
        dispatch(servicesFetchData(filter))
    }
}

export const resetFilter = (filterType) => {
    return (dispatch, getState) => {
        let { services = {} } = getState()
        let { filter = {} } = services
        if (filterType === 'All') {
            filter.selectedBenefit = ''
            filter.selectedDate = ''
            filter.selectedCategory = ''
            filter.startDate = services.cruiseStartDate
            filter.endDate = services.cruiseEndDate
            filter.selectedDuration = 'Any'
            filter.selectedGuest = ''
            filter.selectedGuestDetails = ''
            filter.selectedTimeSlot = ''
        } else {
            filter[filterType] = ''
            if (filterType === 'selectedDate') {
                filter.startDate = services.cruiseStartDate
                filter.endDate = services.cruiseEndDate
                filter.selectedTimeSlot = ''
            }
            if (filterType === 'selectedGuest') {
                filter.selectedGuestDetails = ''
            }
        }
        dispatch(setFilter({ ...filter }))
        dispatch(servicesFetchData({ ...filter }))
    }
}

export const filterByDuration = (selectedDuration, selectedSort) => {
    return (dispatch, getState) => {
        let { services } = getState()
        let _selectedDuration = durationOptions.find((option) => option.label === selectedDuration)
        if (_selectedDuration) {
            let { filter } = services
            filter.selectedDuration = selectedDuration
            dispatch(setFilter({ ...filter }))
            dispatch(servicesFetchData({ ...filter }, undefined, selectedSort))
        }
    }
}

export const sortAvailableServices = (selectedSort) => {
    return (dispatch, getState) => {
        let { services } = getState();
        let _availableServices = servicesHelpers.getSortedResults(selectedSort, services.availableServices)
        dispatch(itemsFetchDataSuccess(_availableServices))
    }
}

export const selectGuest = (selectedGuest) => {
    return  (dispatch, getState) => {
        let { services = {} } = getState(),
            { filter = {} } = services,
            userName = '',
            _label = ''
        if (selectedGuest === 'All Guests') {
            selectedGuest = {}
            _label = 'All Guests'
        } else {
            userName = selectedGuest.PassengerDetail ? selectedGuest.PassengerDetail.Name : ''
            _label = userName ? `${userName.FirstName} ${userName.LastName}` : ''
        }

        let isSelectedGuest = (filter.selectedGuestDetails) ? (filter.selectedGuest === _label && filter.selectedGuestDetails.PaxId === selectedGuest.PaxId) : false;
        let guestDetails = isSelectedGuest ? {} : selectedGuest;
        filter.selectedGuest = isSelectedGuest ? '' : _label;
        filter.selectedGuestDetails = (filter.selectedGuest) ? selectedGuest : '';
        dispatch(setFilter({ ...filter }))
        dispatch(setSelectedGuestDetails(guestDetails))
        dispatch(servicesFetchData(filter));
    }
}

export const setSelectedGuestDetails = (selectedGuest) => {
    return {
        type: SET_SELECTED_GUEST_DETAILS,
        selectedGuestDetails: selectedGuest,
    }
}

export const selectTimeSlot = (selectedTimeSlot) => {
    return  (dispatch, getState) => {
        let { services = {} } = getState()
        let { filter = {} } = services
        filter.selectedTimeSlot = (filter.selectedTimeSlot === selectedTimeSlot) ? '' : selectedTimeSlot;
        dispatch(setFilter({ ...filter }))
        dispatch(servicesFetchData({ ...filter }))
    }
}

export const selectService = (selectedService) => {

    return {
        type: SET_SELECTED_SERVICE,
        selectedService,
    }
}

export const setItenaryDetails = (itineraries, itineraryMap) => {
    return {
        type: SET_ITINERARIES,
        itineraries,
        itineraryMap,
    }
}

export const getItinerary = (url) => {
    return async (dispatch, getState) => {
        try {
            let _reqHeader = {}
            //await dispatch(getDBToken())
            let { services } = getState()
            
            _reqHeader.AppId = '{"IP":"127.0.0.1","id":"PB"}'
            _reqHeader.ProductCompany = 'PC'
            _reqHeader.BookingCompany = 'PC'
            _reqHeader.ReqSrc = 'W'
            _reqHeader['pcl-client-id'] = pclClientId	

            let voyage = services.bookingDetails.Product.Cruise.Voyage
            let querURl = `${polarItenerariesToken}?cruises=${voyage.Id}&fromRoutePort=${voyage.StartRoutePortId}&toRoutePort=${voyage.EndRoutePortId}`
            const response = await getData(querURl, _reqHeader)
            //console.log(response);
            if (!response.ok) {
                throw Error(response.statusText)
            }
            let payload = response.json()
            payload
                .then((items) => {
                    let portsData = servicesHelpers.processItineraryData(items, dispatch)
                    servicesHelpers.setItinerary(portsData, dispatch)
                })
                .catch((e) => showSpaError('Error While Fetching Itinerary Details'))
        } catch (e) {
            showSpaError('Error While Fetching Itinerary Details')
        }
    }
}

export const getCPNavigationHeader = (FirstName, LastName, bookinNum) => {
    return async (dispatch, getState) => {
        let _reqHeader = apiRequestsConstants['sendRequestCpNavHeader'];
        _reqHeader.AppId.bookNum = bookinNum;
        _reqHeader.AppId = JSON.stringify(_reqHeader.AppId);
        _reqHeader.ProductCompany = 'PC';
        _reqHeader.BookingCompany = 'PC';
        _reqHeader['pcl-client-id'] = pclClientId;
        
        let querURl = `${cpNavigationHeaderUrl}?firstName=${FirstName}&lastName=${LastName}&&bookingId=${bookinNum}`
        const response = await getData(querURl, _reqHeader);
        if (!response.ok) {
            console.log('Error in CP Nav Data');
            return
        }
        let payload = response.json()
        payload.then((items) => servicesHelpers.processCPNavData(items, dispatch))
    }
}

export const setCPNavMenuData = (cpNavdata, cpDaysToVoyage) => {
    return {
        type: SET_NAV_DATA,
        cpNavdata,
        cpDaysToVoyage,
    }
}

export const getAllContentFeed = () => {
    return async (dispatch, getState) => {
        let { services } = getState();
        let reqHeader = {}
        reqHeader.AuthToken = services.authDetails.AuthToken
        reqHeader.AppId = 'SPA' + services.authDetails.AuthToken
        reqHeader.ProductCompany = 'PC';
        reqHeader.BookingCompany = 'PC';
        reqHeader['pcl-client-id'] = pclClientId	
        
        const response = await getData(getContentFeed, reqHeader)
        //console.log(response);
        if (!response.ok) {
            
            throw Error(response.statusText)
        }
        let payload = response.json()
        payload
            .then((items) => {
                //console.log('contentFeed ---->', items)
                dispatch(setContentFeed(items, dispatch))
            })
            .catch((e) => {
                //console.log('contentFeed  Error---->', e)
            })
    }
}

export const setContentFeed = (items) => {
    return {
        type: SET_CONTENT_FEED,
        contentFeedData: items.data,
    }
}

export const setAuthTokenDetails = (queryInfo) => {
    return {
        type: SET_AUTH_TOKEN,
        queryInfo,
    }
}

export const setQueryInfoFromUrl = (queryInfo) => {
    return (dispatch, getState) => {
        let _queryParms = {}
        _queryParms.AuthToken = queryInfo.token
        _queryParms.bookingCompany = queryInfo.bookingCompany
        _queryParms.productCompany = queryInfo.productCompany
        let { services } = getState()
        let { authDetails = false } = services

        try {
            if (queryInfo.token && queryInfo.bookingCompany) {
                if (authDetails && authDetails.AuthToken === queryInfo.token)
                    return
                let appTrigger = (queryInfo.token.charAt(4) === 'C') ? 'CP' : 'POLAR';
                _queryParms.appTrigger = appTrigger;
                dispatch(userLogOut())
                dispatch(setAuthTokenDetails(_queryParms))
                dispatch(getReservedServices(reservedServices))
            } else {
                dispatch(unauthorizedAccess())
            }
        } catch {
            dispatch(unauthorizedAccess())
        }
    }
}

const unauthorizedAccess = () => {
    return (dispatch) => {
        dispatch(showSpaError('Unauthorized Access', true));
    }
}

//export const setPayerField  = (payer) =>dispatch=>setPayer(payer);

export const setPayer = (payer) => {
    return {
        type: SET_GUEST_PAYER,
        payer,
    }
}

export const clearLandingDetails = () => {
    return  (dispatch) => {
        dispatch(setNotificationBanner('', ''))
        dispatch(setPayer({}))
        dispatch(cancelSuccess(false))
        dispatch(setPaymentLoader(false))
    }
}

export const selectGuestPayer = (payer) => {
    return  (dispatch, getState) => {
        let { services } = getState()
        let _payer = services.payer
        if (payer) {

            _payer.PaxId = payer.PaxId
            _payer.FirstName = payer.PassengerDetail.Name.FirstName
            _payer.LastName = payer.PassengerDetail.Name.LastName
            _payer.Age = payer.Age
            _payer.Email = payer.Email
            _payer.Gender = payer.Gender
            _payer.Address = payer.PassengerDetail.Address.Line1
            _payer.PostCode = payer.PassengerDetail.Address.PostCode
            _payer.StateId = payer.PassengerDetail.Address.StateId
            _payer.City = payer.PassengerDetail.Address.City
            _payer.isCardHoldSelected = 'true';
            dispatch(setPayer(_payer))
        }
        else {
            let _emptyPayer = {};
            _emptyPayer.isCardHoldSelected = 'true';
            _emptyPayer.paymentType = _payer.paymentType;
            dispatch(setPayer(_emptyPayer));
        }
    }
}

export const setScreenLoading = (bool) =>
    ({
        type: 'SET_SCREEN_LOADER',
        isScreenLoading: bool
    });

export const addReservations = (reqObj) => {
    return  (dispatch, getState) => {
        let { services } = getState();
        let { polarRes } = services;
        let _reqObj = reqObj;
        let polarGuests = polarRes.AS01R_Retrieve_Spa_Appts.Guest;
        let reqGuests = _reqObj.AS05Q_Add_Spa_Appts.Guest;
        let combinedApp = polarGuests.map((pGuest) => {
            let rGuest = reqGuests.find((guest) => guest.PaxId === pGuest.PaxId);
            if (rGuest && rGuest.SpaAppointments && rGuest.SpaAppointments.length > 0) {
                pGuest.SpaAppointments = [...pGuest.SpaAppointments, ...rGuest.SpaAppointments];
                return pGuest;
            }
            return pGuest;
        })

        polarRes.Guest = combinedApp;
        servicesHelpers.processBookingDetails(polarRes, dispatch, getState);

    }
}

var historyIn;
export const setServicesDataFromId = (spaId, history) => {
    return (dispatch, getState) => {
        dispatch(setScreenLoading(true));
        dispatch(servicesFetchData({}, spaId));
        historyIn = history;
        //dispatch(selectServiceFromId())
    }
}

export const selectServiceFromId = (spaId) => {
    return  (dispatch, getState) => {
        let { services } = getState();
        //console.log(services);
        let { availableServices = {}, contentFeedData = false } = services;
        let selectedService = availableServices.find((serviceItem) => serviceItem.treatmentId === spaId);
        if (selectedService) {
            dispatch(selectService(selectedService));
        } else {
            let serviceCreated = {};
            serviceCreated.treatmentId = spaId;
            let contentData = contentFeedData.find(
                // eslint-disable-next-line eqeqeq
                (data) => data.productCode == spaId
            ) || {};
            serviceCreated.treatmentDesc = contentData.productName;
            serviceCreated.isNoAvailable = true;
            dispatch(selectService({ ...serviceCreated, ...contentData }));
        }
        dispatch(setScreenLoading(false));
        historyIn.push('/reserve');
    }
}
export const removeReservations = (reqObj) => {
    return  (dispatch, getState) => {
        let { services } = getState();
        let { polarRes } = services;
        let polarGuests = polarRes.AS01R_Retrieve_Spa_Appts.Guest;
        let reqGuest = reqObj.POLARRequest.AS06Q_Cancel_Spa_Appts.Guest;
        let combinedApp = polarGuests.filter((pGuest) => {
            if (reqGuest && reqGuest.SpaAppointments && reqGuest.PaxId === pGuest.PaxId) {
                pGuest.SpaAppointments = pGuest.SpaAppointments.filter((app) => reqGuest.SpaAppointments.ResHoldId !== app.ResHoldId);
                return pGuest;
            }
            return pGuest;
        })
        polarRes.Guest = combinedApp;
        servicesHelpers.processBookingDetails(polarRes, dispatch, getState);
    }
}

export const setDaysToCruise = (days) => ({
    type: 'SET_DAYS_CRUISE',
    daysToCruise: days
});
